import { render, staticRenderFns } from "./achievementItem.vue?vue&type=template&id=729c2560&scoped=true"
import script from "./achievementItem.vue?vue&type=script&lang=js"
export * from "./achievementItem.vue?vue&type=script&lang=js"
import style0 from "./achievementItem.vue?vue&type=style&index=0&id=729c2560&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c2560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729c2560')) {
      api.createRecord('729c2560', component.options)
    } else {
      api.reload('729c2560', component.options)
    }
    module.hot.accept("./achievementItem.vue?vue&type=template&id=729c2560&scoped=true", function () {
      api.rerender('729c2560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/achievementItem.vue"
export default component.exports